import React from 'react'
import TransitOperations from '../../routes/phase5/TransitOperationTable'

function TransitListPage() {
  return (<TransitOperations />)
}

export default TransitListPage
